import upperFirst from "lodash/upperFirst";

export const convertMutationErrors = (errors) =>
  errors.reduce(
    (acc, { key, message }) => ({
      ...acc,
      [key]: [...(acc[key] || []), new Error(upperFirst(message))],
    }),
    {}
  );
